import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
    categoryName: '外部パートナー連携',

    // model
    partnerModel: [],
    serviceModel: [],
    tenantModel: [],
    communityModel: [],

    // 検索
    filters: {
        name: null,
        email: null,
        serviceUuid: '',
        status: '',
        tenantUuid: '',
        communityUuid: '',
    }
}

const getters = {
    get: state => state
}

const actions = {
    /**
     * 初期データを読出し
     */
    loadModel({commit}, {partnerParams, serviceDetailParams}) {
        let tenantParams = {
            filters: {
                tenantStatus: 1
            }
        }
        let communityParams = {
            filters: {
                communityStatus: 1
            }
        }

        return new Promise((resolve, reject) => {
            const isAdmin = this.getters['auth/isAdmin']

            let types = [
                'partner',
                'tenant',
                'community'
            ]
            let methods = [
                'v1PartnerListGet',
                'v1TenantListGet',
                'v1CommunityListGet'
            ]
            let parameters = [
                partnerParams,
                tenantParams,
                communityParams
            ]

            // システム管理者の場合
            if (isAdmin) {
                types.push('service')
                methods.push('v1ServiceListGet')
                parameters.push({})
                // サービス運用者の場合
            } else {
                types.push('service')
                methods.push('v1ServiceDetailGet')
                parameters.push(serviceDetailParams)
            }

            ApiManager.request(types, methods, parameters)
                .then(res => {
                    let status = Utility.parseResponse(res)
                    console.log(' =>', status)
                    if (status.result) {
                        // 正常処理
                        console.log(res)
                        commit("setPartnerModel", res[0].data.partners)
                        commit('setTenantModel', res[1].data.tenants)
                        commit('setCommunityModel', res[2].data.communities)
                        commit('setServiceModel', res[3].data.serviceInfo)
                        console.log('partnerModel', state.partnerModel)
                        console.log('tenantModel', state.tenantModel)
                        console.log('communityModel', state.communityModel)
                        console.log('serviceModel', state.serviceModel)
                        resolve()
                    } else if (status.error) {
                        // エラーメッセージ表示
                        reject(res)
                    } else {
                        // アプリケーションエラー表示
                        reject(null)
                    }
                })
                .catch(error => {
                    // アプリケーションエラー表示
                    reject(null)
                })
        })
    },
    /**
     * 外部連携パートナー一覧を読出し
     */
    loadPartnerList({commit}, {partnerParams}) {
        return new Promise((resolve, reject) => {
            ApiManager.request(
                ['partner'],
                ['v1PartnerListGet'],
                [partnerParams])
                .then(res => {
                    let status = Utility.parseResponse(res)
                    if (status.result) {
                        commit('setPartnerModel', res[0].data.partners)
                        console.log('partnerModel', state.partnerModel)
                        resolve()

                    } else if (status.error) {
                        // エラーメッセージ表示
                        reject(res)
                    } else {
                        // アプリケーションエラー表示
                        reject(null)
                    }
                })
                .catch(error => {
                    // アプリケーションエラー表示
                    console.log(error)
                    reject(null)
                })
        })
    },
    reset({commit}) {
        commit('resetState')
    }
}

const mutations = {
    // model
    setPartnerModel(state, data) {
        Vue.set(state, 'partnerModel', data)
    },
    setServiceModel(state, data) {
        Vue.set(state, 'serviceModel', data)
    },
    setTenantModel(state, data) {
        Vue.set(state, 'tenantModel', data)
    },
    setCommunityModel(state, data) {
        Vue.set(state, 'communityModel', data)
    },

    setInputFilter(state, {key, value}) {
        Vue.set(state.filters, key, value)
    },

    resetState(state) {
        Vue.set(state, 'partnerModel', [])
        Vue.set(state, 'serviceModel', [])
        Vue.set(state, 'tenantModel', [])
        Vue.set(state, 'communityModel', [])

        state.filters.name = null
        state.filters.email = null
        state.filters.serviceUuid = ''
        state.filters.status = ''
        state.filters.tenantUuid = ''
        state.filters.communityUuid = ''
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
